import type { TelemetryEvent } from '@ms/yammer-telemetry';
import { getNavigationStartTimestamp } from '@ms/yammer-telemetry';
import { getUserClickTime } from 'state/teamsContext/selectors';
import type { YammerTeamsNativeState } from 'state/types';

type AddPerfTimingsToEvent = <T extends YammerTeamsNativeState>(
  event: TelemetryEvent,
  getState: () => T
) => TelemetryEvent;
export const addPerfTimingsToEvent: AddPerfTimingsToEvent = (event) => {
  const userClickTime = getUserClickTime();
  const navigationStart = getNavigationStartTimestamp();
  if (!userClickTime && !navigationStart) {
    return event;
  }

  // oxlint-disable-next-line typescript/consistent-type-assertions
  return {
    ...event,
    properties: {
      ...event.properties,
      userClickTime,
      navigationStart,
    },
  } as TelemetryEvent;
};
